export default __webpack_public_path__ + "media/zurb/img/home/home-tool-helio-12cd3e1b4a73b59d33eda494058b1d66.png";